import React, { useState } from 'react';
import { Hero } from './components/Hero';
import { Modules } from './components/Modules';
import { Testimonials } from './components/Testimonials';
import { Bio } from './components/Bio';
import { Footer } from './components/Footer';
import { RegistrationPopup } from './components/RegistrationPopup';
export function App() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-brand-orange selection:text-white" data-id="element-0">
      {/* Main Sections */}
      <main data-id="element-1">
        <Hero onOpenPopup={openPopup} data-id="element-2" />
        <Modules onOpenPopup={openPopup} data-id="element-3" />
        <Testimonials onOpenPopup={openPopup} data-id="element-4" />
        <Bio onOpenPopup={openPopup} data-id="element-5" />
      </main>

      {/* Footer */}
      <Footer data-id="element-6" />

      {/* Registration Modal */}
      <RegistrationPopup isOpen={isPopupOpen} onClose={closePopup} data-id="element-7" />
    </div>;
}